module.exports = __webpack_public_path__ + "static/media/bgimage.8c905a75.png";